export default {
	$accessibility: {
		archived: "Lưu trữ",
		present: "Hiện tại",
	},
	$accessModifier: {
		$description: {
			hidden_from_receiver: "Ẩn khỏi người nhận",
			hidden_from_sender: "Ẩn khỏi người gửi",
			private: "Riêng tư",
			shared_with_custom: "Chia sẻ tùy chỉnh",
			shared_with_everyone: "Chia sẻ với mọi người",
			shared_with_receiver: "Chia sẻ với người nhận",
			shared_with_sender: "Chia sẻ với người gửi",
		},
	},
	$antProduct: {
		limitGBStorage: "{limit}GB Dung lượng",
		limitMBStorage: "{limit}MB Dung lượng",
		limitUser: "{limit} Người dùng",
		limitUsers: "{limit} Người dùng",
		renewAtPricePerUnit: "Gia hạn với giá {currency}{price} cho mỗi {unit}",
		unlimitedModule: "Không giới hạn {module}",
		upToLimitModule: "Tối đa {limit} {module}",
	},
	$company: {
		address: "Kotekli Mah. Denizli Yolu Bul. Teknopark Sitesi B Blok No:4B Ic kapi No:14 MENTESE / MUGLA, TURKEY",
		googleMapSrc:
			"https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12715.523446137679!2d28.3731307!3d37.1793022!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bf732687fd3eb1%3A0x2815d6eefcce8910!2sMu%C4%9Fla%20Teknopark!5e0!3m2!1svi!2str!4v1701805110461!5m2!1svi!2str",
		name: "Slush Software Inc.",
		phoneNumber: "+90 (555) 444-33-22",
		slogan:
			"Thúc đẩy doanh nghiệp của bạn với Antrego. Quản lý quy trình giao hàng của bạn một cách kỹ thuật số, an toàn và dễ dàng.",
	},
	$cookieBanner: {
		accept: "Chấp nhận",
		decline: "Từ chối",
		message:
			"Chúng tôi sử dụng cookie và các công nghệ tương tự để phân tích và cá nhân hóa nội dung. Bằng cách nhấp vào 'Chấp nhận', bạn đồng ý với việc sử dụng các công nghệ này.",
	},
	$country: {
		afghanistan: "Afghanistan",
		aland: "Åland",
		albania: "Albania",
		algeria: "Algeria",
		american_samoa: "Samoa thuộc Mỹ",
		andorra: "Andorra",
		angola: "Angola",
		anguilla: "Anguilla",
		antarctica: "Nam Cực",
		antigua_and_barbuda: "Antigua và Barbuda",
		argentina: "Argentina",
		armenia: "Armenia",
		aruba: "Aruba",
		australia: "Úc",
		austria: "Áo",
		azerbaijan: "Azerbaijan",
		bahamas: "Bahamas",
		bahrain: "Bahrain",
		bangladesh: "Bangladesh",
		barbados: "Barbados",
		belarus: "Belarus",
		belgium: "Bỉ",
		belize: "Belize",
		benin: "Benin",
		bermuda: "Bermuda",
		bhutan: "Bhutan",
		bolivia: "Bolivia",
		bonaire_sint_eustatius_and_saba: "Bonaire, Sint Eustatius và Saba",
		bosnia_and_herzegovina: "Bosnia và Herzegovina",
		botswana: "Botswana",
		bouvet_island: "Đảo Bouvet",
		brazil: "Brazil",
		british_indian_ocean_territory: "Lãnh thổ Ấn Độ Dương thuộc Anh",
		british_virgin_islands: "Quần đảo Virgin thuộc Anh",
		brunei: "Brunei",
		bulgaria: "Bulgaria",
		burkina_faso: "Burkina Faso",
		burundi: "Burundi",
		cabo_verde: "Cabo Verde",
		cambodia: "Campuchia",
		cameroon: "Cameroon",
		canada: "Canada",
		cayman_islands: "Quần đảo Cayman",
		central_african_republic: "Cộng hòa Trung Phi",
		chad: "Chad",
		chile: "Chile",
		china: "Trung Quốc",
		christmas_island: "Đảo Giáng Sinh",
		cocos_islands: "Quần đảo Cocos (Keeling)",
		colombia: "Colombia",
		comoros: "Comoros",
		congo_republic: "Cộng hòa Congo",
		cook_islands: "Quần đảo Cook",
		costa_rica: "Costa Rica",
		croatia: "Croatia",
		cuba: "Cuba",
		curacao: "Curaçao",
		cyprus: "Síp",
		czechia: "Cộng hòa Séc",
		denmark: "Đan Mạch",
		djibouti: "Djibouti",
		dominica: "Dominica",
		dominican_republic: "Cộng hòa Dominica",
		dr_congo: "Cộng hòa Dân chủ Congo",
		ecuador: "Ecuador",
		egypt: "Ai Cập",
		el_salvador: "El Salvador",
		equatorial_guinea: "Guinea Xích Đạo",
		eritrea: "Eritrea",
		estonia: "Estonia",
		eswatini: "Eswatini",
		ethiopia: "Ethiopia",
		falkland_islands: "Quần đảo Falkland",
		faroe_islands: "Quần đảo Faroe",
		fiji: "Fiji",
		finland: "Phần Lan",
		france: "Pháp",
		french_guiana: "Guiana thuộc Pháp",
		french_polynesia: "Polynesia thuộc Pháp",
		french_southern_territories: "Lãnh thổ phía Nam của Pháp",
		gabon: "Gabon",
		gambia: "Gambia",
		georgia: "Georgia",
		germany: "Đức",
		ghana: "Ghana",
		gibraltar: "Gibraltar",
		greece: "Hy Lạp",
		greenland: "Greenland",
		grenada: "Grenada",
		guadeloupe: "Guadeloupe",
		guam: "Guam",
		guatemala: "Guatemala",
		guernsey: "Guernsey",
		guinea: "Guinea",
		guinea_bissau: "Guinea-Bissau",
		guyana: "Guyana",
		haiti: "Haiti",
		heard_island_and_mcdonald_islands: "Đảo Heard và Quần đảo McDonald",
		honduras: "Honduras",
		hong_kong: "Hồng Kông",
		hungary: "Hungary",
		iceland: "Iceland",
		india: "Ấn Độ",
		indonesia: "Indonesia",
		iran: "Iran",
		iraq: "Iraq",
		ireland: "Ireland",
		isle_of_man: "Đảo Man",
		israel: "Israel",
		italy: "Ý",
		ivory_coast: "Bờ Biển Ngà",
		jamaica: "Jamaica",
		japan: "Nhật Bản",
		jersey: "Jersey",
		jordan: "Jordan",
		kazakhstan: "Kazakhstan",
		kenya: "Kenya",
		kiribati: "Kiribati",
		kosovo: "Kosovo",
		kuwait: "Kuwait",
		kyrgyzstan: "Kyrgyzstan",
		laos: "Lào",
		latvia: "Latvia",
		lebanon: "Liban",
		lesotho: "Lesotho",
		liberia: "Liberia",
		libya: "Libya",
		liechtenstein: "Liechtenstein",
		lithuania: "Lithuania",
		luxembourg: "Luxembourg",
		macao: "Macao",
		madagascar: "Madagascar",
		malawi: "Malawi",
		malaysia: "Malaysia",
		maldives: "Maldives",
		mali: "Mali",
		malta: "Malta",
		marshall_islands: "Quần đảo Marshall",
		martinique: "Martinique",
		mauritania: "Mauritania",
		mauritius: "Mauritius",
		mayotte: "Mayotte",
		mexico: "Mexico",
		micronesia: "Micronesia",
		moldova: "Moldova",
		monaco: "Monaco",
		mongolia: "Mông Cổ",
		montenegro: "Montenegro",
		montserrat: "Montserrat",
		morocco: "Ma Rốc",
		mozambique: "Mozambique",
		myanmar: "Myanmar",
		namibia: "Namibia",
		nauru: "Nauru",
		nepal: "Nepal",
		netherlands: "Hà Lan",
		new_caledonia: "New Caledonia",
		new_zealand: "New Zealand",
		nicaragua: "Nicaragua",
		niger: "Niger",
		nigeria: "Nigeria",
		niue: "Niue",
		norfolk_island: "Đảo Norfolk",
		north_korea: "Bắc Triều Tiên",
		north_macedonia: "Bắc Macedonia",
		northern_mariana_islands: "Quần đảo Bắc Mariana",
		norway: "Na Uy",
		oman: "Oman",
		pakistan: "Pakistan",
		palau: "Palau",
		palestine: "Palestine",
		panama: "Panama",
		papua_new_guinea: "Papua New Guinea",
		paraguay: "Paraguay",
		peru: "Peru",
		philippines: "Philippines",
		pitcairn_islands: "Quần đảo Pitcairn",
		poland: "Ba Lan",
		portugal: "Bồ Đào Nha",
		puerto_rico: "Puerto Rico",
		qatar: "Qatar",
		reunion: "Réunion",
		romania: "Romania",
		russia: "Nga",
		rwanda: "Rwanda",
		saint_barthelemy: "Saint Barthélemy",
		saint_helena: "Saint Helena",
		saint_lucia: "Saint Lucia",
		saint_martin: "Saint Martin",
		saint_pierre_and_miquelon: "Saint Pierre và Miquelon",
		samoa: "Samoa",
		san_marino: "San Marino",
		sao_tome_and_principe: "São Tomé và Príncipe",
		saudi_arabia: "Ả Rập Saudi",
		senegal: "Senegal",
		serbia: "Serbia",
		seychelles: "Seychelles",
		sierra_leone: "Sierra Leone",
		singapore: "Singapore",
		sint_maarten: "Sint Maarten",
		slovakia: "Slovakia",
		slovenia: "Slovenia",
		solomon_islands: "Quần đảo Solomon",
		somalia: "Somalia",
		south_africa: "Nam Phi",
		south_georgia_and_south_sandwich_islands: "Nam Georgia và Quần đảo Nam Sandwich",
		south_korea: "Hàn Quốc",
		south_sudan: "Nam Sudan",
		spain: "Tây Ban Nha",
		sri_lanka: "Sri Lanka",
		st_kitts_and_nevis: "St Kitts và Nevis",
		st_vincent_and_grenadines: "Saint Vincent và Grenadines",
		sudan: "Sudan",
		suriname: "Suriname",
		svalbard_and_jan_mayen: "Svalbard và Jan Mayen",
		sweden: "Thụy Điển",
		switzerland: "Thụy Sĩ",
		syria: "Syria",
		taiwan: "Đài Loan",
		tajikistan: "Tajikistan",
		tanzania: "Tanzania",
		thailand: "Thái Lan",
		timor_leste: "Đông Timor",
		togo: "Togo",
		tokelau: "Tokelau",
		tonga: "Tonga",
		trinidad_and_tobago: "Trinidad và Tobago",
		tunisia: "Tunisia",
		turkiye: "Thổ Nhĩ Kỳ",
		turkmenistan: "Turkmenistan",
		turks_and_caicos_islands: "Quần đảo Turks và Caicos",
		tuvalu: "Tuvalu",
		uganda: "Uganda",
		ukraine: "Ukraine",
		united_arab_emirates: "Các Tiểu Vương Quốc Ả Rập Thống Nhất",
		united_kingdom: "Vương quốc Anh",
		united_states: "Hoa Kỳ",
		uruguay: "Uruguay",
		us_minor_outlying_islands: "Các đảo xa xôi nhỏ của Mỹ",
		us_virgin_islands: "Quần đảo Virgin thuộc Mỹ",
		uzbekistan: "Uzbekistan",
		vanuatu: "Vanuatu",
		vatican_city: "Thành phố Vatican",
		venezuela: "Venezuela",
		vietnam: "Việt Nam",
		wallis_and_futuna: "Wallis và Futuna",
		western_sahara: "Tây Sahara",
		yemen: "Yemen",
		zambia: "Zambia",
		zimbabwe: "Zimbabwe",
	},
	$currency: {
		euro: "Euro",
		turkish_lira: "Lira Thổ Nhĩ Kỳ",
		us_dollar: "Đô la Mỹ",
	},
	$documentManager: {
		message_1: 'Để chỉnh sửa mẫu, hãy nhấp vào nút "Chỉnh sửa Mẫu" để vào màn hình chỉnh sửa.',
		message_2: 'Bạn có thể thay đổi số hàng trong danh sách bằng cách tăng hoặc giảm "Số hàng".',
		message_3: 'Các thay đổi trong các trường nội dung sẽ ngay lập tức hiển thị trong phần "Xem trước".',
		message_4: 'Để tạo PDF, hãy nhấp vào nút "Thao tác tài liệu" để lưu dưới dạng PDF.',
		message_5: 'Để truy cập tài liệu sau này, bạn có thể lưu chúng qua nút "Thao tác tài liệu".',
		message_6: "Dữ liệu nhập vào mỗi ô của bảng sẽ hiển thị chính xác trong phần xem trước.",
		message_7: "Bảng dữ liệu có thể chỉnh sửa giống như một bảng tính Excel hoặc một trang tính điện tử.",
	},
	$employeeType: {
		admin: "Quản trị viên",
		default: "Mặc định",
		exporter: "Nhà xuất khẩu",
		importer: "Nhà nhập khẩu",
	},
	$format: {
		date: "DD/MM/YYYY",
		date_time: "DD/MM/YYYY HH:mm:ss",
		date_time_without_second: "DD/MM/YYYY HH:mm",
	},
	$home: {
		$noCompany: {
			create_company_subtitle: "Tạo công ty của bạn tại đây.",
			create_company_title: "Bạn muốn thêm công ty của mình?",
			description: "Bạn đã đăng nhập thành công. Bây giờ bạn cần tham gia một công ty hoặc tạo một công ty mới.",
			join_company_subtitle: "Nhập mã của bạn và tham gia công ty tại đây.",
			join_company_title: "Bạn muốn tham gia một công ty hiện có?",
			title: "Chào mừng {name}",
		},
		$unauthorized: {
			description: "Kiểm soát các quy trình xuất nhập khẩu của bạn với Antrego",
			forget_password_subtitle: "Nhập email của bạn để đặt lại mật khẩu.",
			sign_in_subtitle: "Đăng nhập tại đây",
			sign_in_title: "Bạn đã có tài khoản?",
			sign_up_subtitle: "Đăng ký tại đây",
			sign_up_title: "Bạn muốn tạo tài khoản?",
			title: "Chào mừng đến với Antrego",
		},
	},
	$invitationType: {
		company_partner: "Lời mời hợp tác thương mại",
		customs_partner: "Lời mời đối tác hải quan",
		employee: "Lời mời nhân viên",
	},
	$landing: {
		$benefits: {
			$detailPage: {
				hero_title: "Biến đổi Hoạt động Kinh doanh của Bạn",
				hero_subtitle: "Lợi ích của Nền tảng",
				hero_description:
					"Khám phá cách Antrego tinh gọn toàn bộ quy trình logistics của bạn, từ quản lý tồn kho đến theo dõi lô hàng. Trải nghiệm hiệu quả cao hơn, chi phí thấp hơn và cộng tác được tăng cường trên toàn tổ chức.",
				features_title: "Lợi ích Toàn diện của Nền tảng",
				feature_1_title: "Bảng điều khiển tập trung",
				feature_1_desc:
					"Truy cập tất cả dữ liệu logistics, lô hàng, tồn kho và tài liệu từ một giao diện trực quan duy nhất.",
				feature_2_title: "Độ chính xác dữ liệu được nâng cao",
				feature_2_desc:
					"Giảm thiểu sai sót với nhập liệu tự động, xác thực và đồng bộ theo thời gian thực trên mọi module.",
				feature_3_title: "Tiết kiệm thời gian",
				feature_3_desc:
					"Tiết kiệm hàng giờ mỗi ngày với quy trình tự động, thông báo thông minh và luồng công việc tinh gọn.",
				feature_4_title: "Cộng tác nhóm",
				feature_4_desc:
					"Cho phép cộng tác liền mạch giữa các nhóm nội bộ, khách hàng, nhà cung cấp và đối tác logistics.",
				feature_5_title: "Giảm chi phí",
				feature_5_desc: "Cắt giảm chi phí vận hành nhờ cải thiện hiệu quả, ít lỗi hơn và tối ưu phân bổ nguồn lực.",
				feature_6_title: "Khả năng mở rộng",
				feature_6_desc: "Phát triển doanh nghiệp tự tin với nền tảng có thể mở rộng dễ dàng theo nhu cầu của bạn.",
				benefits_title: "Vì sao chọn Antrego?",
				benefit_1: "Tầm nhìn toàn diện trên toàn chuỗi cung ứng",
				benefit_2: "Nền tảng đám mây an toàn với mã hóa cấp doanh nghiệp",
				benefit_3: "Thiết kế tương thích di động để truy cập mọi lúc, mọi nơi",
				benefit_4: "Thông báo tự động giúp mọi bên liên quan luôn được cập nhật",
				benefit_5: "Luồng công việc tùy chỉnh phù hợp quy trình doanh nghiệp của bạn",
				benefit_6: "Đội ngũ hỗ trợ tận tâm đảm bảo thành công cho bạn",
				workflow_title: "Antrego Biến đổi Hoạt động của Bạn như thế nào",
				step_1_title: "Hợp nhất hoạt động của bạn",
				step_1_desc:
					"Kết nối quản lý tồn kho, theo dõi lô hàng, xử lý tài liệu và giao tiếp khách hàng trong một nền tảng tích hợp.",
				step_2_title: "Tự động hóa tác vụ thường nhật",
				step_2_desc:
					"Để Antrego xử lý các tác vụ lặp lại như nhập dữ liệu, thông báo và cập nhật trạng thái, giải phóng đội ngũ cho công việc chiến lược.",
				step_3_title: "Kích hoạt cộng tác thời gian thực",
				step_3_desc:
					"Chia sẻ thông tin tức thời với mọi bên liên quan, đảm bảo ai cũng có quyền truy cập các cập nhật và tài liệu mới nhất.",
				step_4_title: "Ra quyết định dựa trên dữ liệu",
				step_4_desc:
					"Tận dụng phân tích và báo cáo toàn diện để nhận diện xu hướng, tối ưu quy trình và thúc đẩy cải tiến liên tục.",
				cta_title: "Sẵn sàng chuyển đổi hoạt động logistics của bạn?",
				cta_button: "Bắt đầu miễn phí hôm nay",
				cta_subtitle: "Không cần thẻ tín dụng • Tham gia cùng 500+ công ty",
			},
			benefits_title: "Lợi ích của Nền tảng",
			business_process: "Tăng tốc quá trình kinh doanh của bạn.",
			control_title: "Kiểm soát với Antrego.",
			highlight_word: "kiểm soát",
			risk_of_error: "Giảm thiểu rủi ro lỗi.",
			text: "Antrego chuyển đổi hoạt động logistics cho nhà xuất khẩu, nhà nhập khẩu, đại lý giao nhận và nhà sản xuất với các giải pháp số đầu-cuối cho quản lý tồn kho, theo dõi lô hàng theo thời gian thực và tự động hóa chứng từ.",
			time_and_cost_savings: "Tiết kiệm thời gian và chi phí.",
		},
		$content: {
			$text: {
				0: "Theo dõi tất cả các chuyến hàng của bạn tại một nơi và kiểm soát tài chính của bạn với báo cáo động.",
				1: "Chia sẻ các cập nhật theo thời gian thực của bạn với khách hàng của bạn để cải thiện chất lượng dịch vụ của bạn.",
				2: "Xem và chia sẻ tất cả các tài liệu liên quan đến chuyến hàng của bạn trong một hệ thống.",
				3: "Dễ dàng kiểm soát quá trình bằng cách truy cập Antrego từ tất cả các thiết bị và địa điểm.",
				4: "Lưu trữ tất cả dữ liệu của bạn bằng công nghệ mã hóa SHA-256. Yên tâm về bảo mật.",
				5: "Tham gia theo dõi chung với tất cả các bên liên quan trong quá trình kinh doanh. Quản lý quy trình hiệu quả hơn.",
			},
			$title: {
				0: "Quản lý lô hàng đầu-cuối",
				1: "Giao tiếp khách hàng theo thời gian thực",
				2: "Quản lý tài liệu tập trung",
				3: "Truy cập trên đám mây ở mọi nơi",
				4: "Bảo mật cấp doanh nghiệp",
				5: "Cộng tác đa bên",
			},
			content_title: "Mọi thứ bạn cần trong một nền tảng",
		},
		$home: {
			subtitle: "Quản lý tồn kho, lô hàng, tài liệu & theo dõi trong một nền tảng mạnh mẽ",
			text: "Tiết kiệm 40% thời gian vận hành với quy trình tự động. Tham gia 500+ công ty đang tinh gọn hoạt động logistics trên toàn cầu.",
			title: "Nền tảng Logistics Hoàn chỉnh: Từ Tồn kho đến Giao hàng",
		},
		$lifecycle: {
			headline: "Quy trình",
			info_button: "Nhận thông tin",
			lifecycle_texts: {
				0: "Tải lên các tệp bổ sung để tạo hóa đơn proforma của bạn và chia sẻ ngay lập tức với khách hàng của bạn.",
				1: "Nhập chi tiết chuyến hàng của bạn và thêm tài liệu. Thông báo cho khách hàng của bạn và cùng nhau quản lý tất cả các quy trình vận chuyển qua một kênh duy nhất.",
				2: "Theo dõi tình hình tài chính của bạn liên quan đến xuất nhập khẩu theo thời gian thực.",
			},
			lifecycle_titles: {
				0: "Đăng nhập và tạo hóa đơn Proforma",
				1: "Tạo chuyến hàng",
				2: "Theo dõi hoạt động tài chính",
			},
			productivity_title: "Tăng năng suất và giảm sự phức tạp và lỗi trong 3 bước.",
			tracking_guide_title: "Hướng dẫn theo dõi dễ dàng",
		},
		$logistics: {
			logistics_title: "Các loại hình logistics được hỗ trợ",
			solutions_title: "Giải pháp phù hợp cho mọi hàng hóa",
			text: "Với Antrego, đối tác kỹ thuật số của bạn trong tất cả các loại hình vận tải, chúng tôi luôn sát cánh cùng bạn trong mọi chuyển động toàn cầu của bạn.",
		},
		$pdfEditor: {
			$detailPage: {
				hero_title: "Tạo tài liệu PDF chuyên nghiệp",
				hero_subtitle: "Tạo các tài liệu thương mại ấn tượng chỉ trong vài phút",
				hero_description:
					"Trình tạo PDF trực quan của Antrego giúp bạn thiết kế, tùy chỉnh và tạo hóa đơn, báo giá proforma và tài liệu thương mại chuyên nghiệp một cách dễ dàng. Không cần kỹ năng thiết kế.",
				features_title: "Mọi thứ bạn cần để tạo tài liệu chuyên nghiệp",
				feature_1_title: "Trình kéo & thả",
				feature_1_desc:
					"Giao diện trực quan cho phép thêm văn bản, hình ảnh, logo và bảng chỉ với thao tác kéo thả. Không cần kỹ thuật.",
				feature_2_title: "Mẫu tùy chỉnh",
				feature_2_desc:
					"Chọn từ các mẫu được thiết kế sẵn hoặc tự tạo bố cục thương hiệu của bạn. Lưu mẫu để đảm bảo thương hiệu nhất quán trên mọi tài liệu.",
				feature_3_title: "Trường biểu mẫu thông minh",
				feature_3_desc:
					"Tự động điền thông tin khách hàng, chi tiết sản phẩm và giá. Kết nối trực tiếp với dữ liệu lô hàng và tồn kho của bạn.",
				feature_4_title: "Tùy chỉnh thương hiệu",
				feature_4_desc:
					"Thêm logo công ty, chọn màu thương hiệu, tùy chỉnh phông chữ và tạo tài liệu thể hiện hoàn hảo bản sắc doanh nghiệp.",
				feature_5_title: "Xuất đa định dạng",
				feature_5_desc:
					"Tải xuống dạng PDF, in trực tiếp hoặc chia sẻ qua email. Tất cả tài liệu đều được định dạng chuyên nghiệp và sẵn sàng in.",
				feature_6_title: "Quản lý phiên bản",
				feature_6_desc:
					"Theo dõi các lần chỉnh sửa, lưu lịch sử và truy cập phiên bản trước. Không bao giờ mất các bản tài liệu quan trọng.",
				benefits_title: "Vì sao chọn Trình tạo PDF của Antrego?",
				benefit_1: "Tạo tài liệu nhanh gấp 10 lần so với phương pháp truyền thống",
				benefit_2: "Duy trì nhận diện thương hiệu nhất quán trên mọi tài liệu thương mại",
				benefit_3: "Giảm lỗi với tự động điền dữ liệu từ lô hàng",
				benefit_4: "Tiết kiệm thời gian với mẫu dùng lại và biểu mẫu thông minh",
				benefit_5: "Gây ấn tượng với khách hàng bằng tài liệu trau chuốt, chuyên nghiệp",
				benefit_6: "Truy cập tài liệu mọi lúc, mọi nơi trên mọi thiết bị",
				workflow_title: "Quy trình tạo PDF",
				step_1_title: "Chọn mẫu",
				step_1_desc: "Chọn từ các mẫu dựng sẵn hoặc bắt đầu với trang trống để tạo bố cục tùy chỉnh.",
				step_2_title: "Tùy chỉnh nội dung",
				step_2_desc: "Kéo thả thành phần, thêm logo và thương hiệu, tự động điền các trường bằng dữ liệu lô hàng.",
				step_3_title: "Xem trước & chỉnh sửa",
				step_3_desc: "Xem tài liệu theo thời gian thực, điều chỉnh và đảm bảo mọi thứ hoàn hảo trước khi tạo.",
				step_4_title: "Tạo & chia sẻ",
				step_4_desc:
					"Tải về dạng PDF, gửi email trực tiếp cho khách hàng hoặc đính kèm vào lô hàng. Lưu mẫu cho lần dùng sau.",
				cta_title: "Bắt đầu tạo tài liệu chuyên nghiệp ngay hôm nay",
				cta_button: "Bắt đầu miễn phí",
				cta_subtitle: "Không cần thẻ tín dụng • Bắt đầu trong vài phút",
			},
			description:
				"Trình chỉnh sửa PDF của chúng tôi là một công cụ mạnh mẽ giúp việc tạo và chỉnh sửa hóa đơn trở nên thực tế hơn. Tiết kiệm thời gian và cung cấp các tài liệu có giao diện chuyên nghiệp cho đối tác kinh doanh của bạn.",
			features: {
				design: "Thiết kế hóa đơn: Thêm logo của bạn, điều chỉnh màu sắc và tùy chỉnh định dạng hóa đơn.",
				edit: "Chỉnh sửa tài liệu: Nhanh chóng chỉnh sửa PDF, thêm hoặc xóa văn bản.",
				shareSave: "Chia sẻ và lưu trữ: Tải xuống, chia sẻ hoặc lưu trữ tài liệu đã tạo trực tiếp trên nền tảng.",
			},
			longTitle: "Hóa đơn nhanh chóng và tùy chỉnh với Trình chỉnh sửa PDF.",
			note: "Cấu hình này cho phép người dùng khám phá tính năng trực quan và xem xét các ưu điểm dưới dạng văn bản.",
			title: "Tạo hóa đơn thật dễ dàng!",
		},
		$process: {
			comparison_subtitle: "So sánh sự khác biệt giữa quản lý logistics truyền thống và số hóa",
			digital_future: "Từ bỏ các phương pháp truyền thống và bước vào tương lai kỹ thuật số",
			digital_shipping: "Theo dõi giao hàng kỹ thuật số với Antrego",
			digital_shipping_texts: {
				0: "Hóa đơn proforma cho các đơn hàng đến được tạo và theo dõi dễ dàng thông qua một kênh duy nhất.",
				1: "Hóa đơn proforma được gửi đi, thông báo đến khách hàng ngay lập tức và được phê duyệt thông qua Antrego.",
				2: "Các quy trình tài liệu được quản lý thông qua Antrego. Chúng không bị mất, không xảy ra chậm trễ và khả năng xảy ra lỗi được giảm thiểu.",
				3: "Các nhà cung cấp, khách hàng và nhà môi giới hải quan có thể ngay lập tức xem chi tiết chuyến hàng và theo dõi chung.",
				4: "Báo cáo tài chính được tự động tạo hàng tháng và hàng năm.",
			},
			question_title: "Antrego giúp bạn tiết kiệm 10+ giờ mỗi tuần như thế nào",
			tracking_method: "Số hóa các phương pháp theo dõi của bạn và tăng tốc quá trình của bạn.",
			traditional_shipping: "Theo dõi giao hàng truyền thống",
			traditional_shipping_texts: {
				0: "Đơn hàng được thu thập qua email, tin nhắn hoặc điện thoại thông qua các kênh khác nhau, gây khó khăn cho việc theo dõi nội bộ.",
				1: "Hóa đơn proforma được tạo bằng các công cụ như Excel và quy trình phê duyệt được xử lý thủ công qua email, WhatsApp hoặc điện thoại.",
				2: "Quy trình tài liệu thủ công dẫn đến lỗi và chậm trễ, gây lãng phí thời gian và tài chính.",
				3: "Không có nền tảng chung cho các nhà cung cấp, khách hàng và nhà môi giới hải quan theo dõi chi tiết chuyến hàng.",
				4: "Dữ liệu tài chính được kiểm tra riêng sau mỗi chuyến hàng, khiến việc báo cáo trở nên khó khăn.",
			},
		},
		$question: {
			$text: {
				0: "<p>Antrego là nền tảng quản lý logistics toàn diện giúp các công ty theo dõi lô hàng, quản lý tồn kho và cộng tác với khách hàng theo thời gian thực. Nền tảng số hóa toàn bộ quy trình chuỗi cung ứng của bạn từ tồn kho đến giao hàng.</p>",
				1: "<p>Antrego đơn giản hóa logistics với Truy cập Dễ dàng từ mọi thiết bị, Bảo mật Dữ liệu cấp doanh nghiệp sử dụng mã hóa SHA-256, và Theo dõi Chung giúp mọi bên liên quan luôn được thông báo trong suốt quá trình vận chuyển.</p>",
				2: "<p>Antrego hỗ trợ tất cả các phương thức vận tải chính bao gồm đường biển, hàng không, đường bộ và đường sắt. Chúng tôi làm việc với mọi hãng vận chuyển và hãng tàu lớn trên toàn thế giới.</p>",
				3: "<p>Antrego cung cấp gói miễn phí cho tối đa 10 lô hàng mỗi tháng mà không cần thẻ tín dụng. Các gói cao cấp bắt đầu từ $99/tháng cho số lô hàng không giới hạn, thanh toán theo năm tiết kiệm 16%. Xem trang bảng giá để biết chi tiết đầy đủ.</p>",
				4: "<p>Chúng tôi hiện đang phát triển quyền truy cập API và khả năng tích hợp với các hệ thống logistics và ERP phổ biến. Tính năng tích hợp dự kiến cho các bản phát hành trong tương lai. Liên hệ với chúng tôi để tìm hiểu thêm về lộ trình và tính năng sắp ra mắt.</p>",
				5: "<p>Hầu hết công ty có thể vận hành trong vòng 24 giờ. Thiết lập cơ bản chỉ mất 5–10 phút để tạo tài khoản và thêm thông tin công ty. Đội ngũ onboarding của chúng tôi sẽ giúp nhập dữ liệu và tùy chỉnh luồng công việc.</p>",
			},
			$title: {
				0: "Antrego là gì?",
				1: "Tại sao tôi nên dùng Antrego?",
				2: "Antrego hỗ trợ loại logistics nào?",
				3: "Antrego có giá bao nhiêu?",
				4: "Tôi có thể tích hợp Antrego với hệ thống hiện có không?",
				5: "Mất bao lâu để thiết lập Antrego?",
			},
			save_percentage: "Tiết kiệm 16% hàng tháng",
			text: "Dễ dàng truy cập tất cả thông tin với Antrego và liên hệ với chúng tôi nếu bạn có bất kỳ câu hỏi nào khác.",
			title: "Nhanh chóng tìm hiểu những gì bạn tò mò",
		},
		$stockFeature: {
			$detailPage: {
				hero_title: "Biến đổi Quản lý Tồn kho của bạn",
				hero_subtitle: "Từ tồn kho đến bán hàng – quản lý toàn bộ vòng đời sản phẩm trên nền tảng số",
				hero_description:
					"Tính năng Quản lý Tồn kho của Antrego giúp nhà xuất khẩu và nhà sản xuất quản lý tồn kho hiệu quả, chia sẻ danh mục sản phẩm với khách hàng và tăng tốc quy trình bán hàng trên một nền tảng tích hợp duy nhất.",
				features_title: "Các tính năng Quản lý Tồn kho mạnh mẽ",
				feature_1_title: "Quản lý tồn kho tập trung",
				feature_1_desc:
					"Quản lý tất cả mặt hàng từ một bảng điều khiển. Theo dõi số lượng, lô, kho và chi tiết sản phẩm một cách dễ dàng.",
				feature_2_title: "Danh mục tồn kho công khai",
				feature_2_desc:
					"Tạo trang danh mục công khai để giới thiệu sản phẩm của bạn tới khách hàng tiềm năng trên toàn cầu. Chia sẻ tồn kho bằng một liên kết đơn giản.",
				feature_3_title: "Theo dõi theo lô",
				feature_3_desc:
					"Theo dõi từng lô hàng tồn với thông tin chi tiết gồm số lượng, kích thước và thuộc tính tùy chỉnh để quản lý chính xác.",
				feature_4_title: "Hỗ trợ đa kho",
				feature_4_desc:
					"Tổ chức tồn kho trên nhiều kho và địa điểm. Theo dõi nơi lưu trữ của từng sản phẩm để logistics hiệu quả.",
				feature_5_title: "Thư viện hình ảnh sản phẩm",
				feature_5_desc:
					"Tải lên nhiều hình ảnh cho mỗi mặt hàng để cung cấp sự rõ ràng trực quan cho khách hàng và thành viên trong đội.",
				feature_6_title: "Chuyển trực tiếp sang lô hàng",
				feature_6_desc:
					"Chuyển đổi liền mạch mặt hàng tồn sang lô hàng. Tạo báo giá proforma và chứng từ lô hàng trực tiếp từ tồn kho.",
				benefits_title: "Vì sao chọn Antrego cho Quản lý Tồn kho?",
				benefit_1: "Tăng khả năng hiển thị sản phẩm tới người mua toàn cầu",
				benefit_2: "Giảm thời gian cho theo dõi tồn kho thủ công",
				benefit_3: "Tinh gọn bước chuyển từ tồn kho sang bán hàng",
				benefit_4: "Cung cấp thông tin tồn kho theo thời gian thực cho khách hàng",
				benefit_5: "Hỗ trợ 15+ ngôn ngữ để vươn tới thị trường quốc tế",
				benefit_6: "Tích hợp với hệ thống lô hàng và lập hóa đơn",
				workflow_title: "Cách hoạt động",
				step_1_title: "Thêm sản phẩm của bạn",
				step_1_desc: "Tạo mặt hàng tồn với thông tin chi tiết gồm thông tin sản phẩm, số lượng, kho và hình ảnh.",
				step_2_title: "Chia sẻ danh mục",
				step_2_desc:
					"Tạo liên kết công khai tới danh mục tồn kho để khách hàng tiềm năng có thể xem và duyệt bất cứ lúc nào.",
				step_3_title: "Nhận yêu cầu",
				step_3_desc: "Khách hàng có thể xem sản phẩm có sẵn và liên hệ trực tiếp để đặt hàng và xin báo giá.",
				step_4_title: "Chuyển đổi thành bán hàng",
				step_4_desc: "Dễ dàng tạo báo giá proforma và lô hàng từ mặt hàng tồn để thực hiện đơn hàng của khách.",
				cta_title: "Sẵn sàng hiện đại hóa quản lý tồn kho của bạn?",
				cta_button: "Bắt đầu miễn phí",
				cta_subtitle: "Không cần thẻ tín dụng • Thiết lập trong vài phút",
			},
			access_potential_customers: "Tiếp cận khách hàng tiềm năng nhanh chóng",
			desc: "Được thiết kế đặc biệt cho các nhà xuất khẩu và nhà sản xuất, Antrego giúp tăng tốc quy trình bán hàng và tiếp thị của bạn. Phát triển doanh nghiệp của bạn với quản lý kho, chia sẻ kho hàng cho khách hàng và quản lý vận chuyển!",
			global_market: "Tham gia thị trường toàn cầu với hỗ trợ 15 ngôn ngữ khác nhau",
			main_title: "Giải pháp thế hệ tiếp theo cho bán hàng và tiếp thị",
			manage_stocks: "Quản lý và chia sẻ kho hàng ngay lập tức",
			speed_up_sales: "Tăng tốc quy trình bán hàng",
			title: "Từ Kho Hàng đến Bán Hàng",
		},
		$tracking: {
			$detailPage: {
				hero_title: "Theo dõi Lô hàng theo Thời gian thực",
				hero_subtitle: "Giám sát mọi container, ở mọi chặng đường",
				hero_description:
					"Hệ thống theo dõi tiên tiến của Antrego cung cấp khả năng hiển thị hoàn toàn cho lô hàng của bạn với cập nhật theo thời gian thực, thông báo tự động và báo cáo trạng thái toàn diện. Không bao giờ để thất lạc container nữa.",
				features_title: "Giải pháp theo dõi hoàn chỉnh",
				feature_1_title: "Theo dõi container trực tiếp",
				feature_1_desc:
					"Theo dõi container theo thời gian thực với vị trí chính xác và thời gian đến dự kiến cho mọi lô hàng.",
				feature_2_title: "Thông báo tự động",
				feature_2_desc:
					"Nhận cảnh báo tức thì cho các mốc quan trọng: xếp hàng, khởi hành, đến nơi, thông quan và trạng thái giao hàng.",
				feature_3_title: "Lịch sử trạng thái",
				feature_3_desc:
					"Truy cập lịch sử lô hàng đầy đủ với nhật ký chi tiết về mọi di chuyển, thay đổi trạng thái và sự kiện chính.",
				feature_4_title: "Hiển thị cho nhiều bên liên quan",
				feature_4_desc:
					"Chia sẻ thông tin theo dõi với khách hàng, nhà cung cấp và đại lý hải quan. Mọi người được cập nhật tự động.",
				feature_5_title: "Quản lý tài liệu",
				feature_5_desc:
					"Đính kèm và truy cập toàn bộ chứng từ lô hàng gồm vận đơn, tờ khai hải quan và chứng nhận tại một nơi.",
				feature_6_title: "Cảnh báo chậm trễ",
				feature_6_desc:
					"Nhận thông báo chủ động về khả năng chậm trễ hoặc vấn đề để bạn kịp thời hành động trước khi sự cố leo thang.",
				benefits_title: "Vì sao chọn Theo dõi của Antrego?",
				benefit_1: "Giảm truy vấn của khách hàng với trang tự tra cứu",
				benefit_2: "Ngăn chậm trễ tốn kém với giám sát chủ động và cảnh báo",
				benefit_3: "Cải thiện hài lòng khách hàng với giao tiếp minh bạch",
				benefit_4: "Tiết kiệm thời gian với cập nhật trạng thái tự động cho mọi bên",
				benefit_5: "Giảm rủi ro nhờ khả năng hiển thị theo thời gian thực về trạng thái lô hàng",
				benefit_6: "Trang theo dõi chuyên nghiệp nâng tầm hình ảnh thương hiệu",
				workflow_title: "Cách theo dõi hoạt động",
				step_1_title: "Tạo lô hàng",
				step_1_desc: "Nhập chi tiết lô hàng gồm số container, tuyến đường và ngày dự kiến vào hệ thống.",
				step_2_title: "Cập nhật tự động",
				step_2_desc: "Hệ thống tự động theo dõi container và cập nhật trạng thái khi đi qua từng điểm kiểm soát.",
				step_3_title: "Thông báo cho các bên liên quan",
				step_3_desc: "Tất cả các bên nhận thông báo tức thời về các mốc quan trọng và thay đổi trạng thái.",
				step_4_title: "Xác nhận giao hàng",
				step_4_desc: "Nhận xác nhận giao cuối cùng với đầy đủ chứng từ và lịch sử lô hàng.",
				cta_title: "Bắt đầu theo dõi lô hàng với sự tự tin",
				cta_button: "Bắt đầu miễn phí",
				cta_subtitle: "Không cần thẻ tín dụng • Bắt đầu theo dõi hôm nay",
			},
			control_title: "Kiểm soát các lô hàng của bạn với Antrego.",
			real_time_alerts:
				"Cảnh báo thời gian thực: Nhận thông báo tức thì và cập nhật trạng thái đầy đủ cho từng container.",
			secure_data_handling:
				"Xử lý dữ liệu an toàn: Dễ dàng tải xuống, chia sẻ hoặc lưu trữ dữ liệu lô hàng của bạn trực tiếp trên nền tảng.",
			tracking_description:
				"Giải pháp theo dõi container của Antrego cung cấp cách nhanh chóng và hiệu quả để giám sát các lô hàng của bạn theo thời gian thực. Giữ vững quyền kiểm soát và gây ấn tượng với các đối tác qua những cập nhật chi tiết, chuyên nghiệp.",
			tracking_title: "Theo dõi lô hàng của bạn một cách dễ dàng!",
		},
		cancel_anytime: "Hủy bất cứ lúc nào",
		customize_package: "Bạn có thể mua thêm dung lượng và người dùng và tùy chỉnh gói của mình theo nhu cầu",
		free_features_1: "10 chuyến hàng",
		free_features_2: "100 MB Dung lượng",
		free_features_3: "Đối tác thương mại không giới hạn",
		free_features_4: "1 người dùng",
		free_plan: "Miễn phí",
		free_price: "$0",
		free_regeneration: "",
		free_title: "Hàng tháng",
		premium_annual_features_1: "20 Người dùng",
		premium_annual_features_2: "100 Đối tác",
		premium_annual_features_3: "1000 Chuyến hàng",
		premium_annual_features_4: "1000 Hóa đơn",
		premium_annual_price: "$83.25",
		premium_annual_regeneration: "Gia hạn hàng năm với $999",
		premium_annual_title: "Hàng năm",
		premium_monthly_features_1: "Chuyến hàng không giới hạn",
		premium_monthly_features_2: "Đối tác thương mại không giới hạn",
		premium_monthly_features_3: "2GB Dung lượng",
		premium_monthly_features_4: "3 Người dùng",
		premium_monthly_price: "$99",
		premium_monthly_regeneration: "Gia hạn hàng tháng với $99",
		premium_monthly_title: "Hàng tháng",
		premium_plan: "Gói Premium",
		premium_plus_annual_features_1: "Chuyến hàng không giới hạn",
		premium_plus_annual_features_2: "Đối tác thương mại không giới hạn",
		premium_plus_annual_features_3: "5GB Dung lượng",
		premium_plus_annual_features_4: "5 Người dùng",
		premium_plus_annual_price: "$83.25",
		premium_plus_annual_regeneration: "Gia hạn hàng năm với $999",
		premium_plus_annual_title: "Hàng năm",
		premium_plus_monthly_features_1: "Chuyến hàng không giới hạn",
		premium_plus_monthly_features_2: "Đối tác thương mại không giới hạn",
		premium_plus_monthly_features_3: "5GB Dung lượng",
		premium_plus_monthly_features_4: "5 Người dùng",
		premium_plus_monthly_price: "$249",
		premium_plus_monthly_regeneration: "Gia hạn hàng tháng với $249",
		premium_plus_monthly_title: "Hàng tháng",
		premium_plus_plan: "Premium Plus",
		pricing_text:
			"Chúng tôi có thể đáp ứng nhu cầu của bạn theo cách tốt nhất mà không làm ảnh hưởng đến ngân sách của bạn.",
		pricing_title: "Antrego cam kết cung cấp gói và giá tốt nhất cho bạn.",
		save_percentage: "Tiết kiệm 16% hàng tháng",
	},
	$language: {
		ar: "العربية",
		de: "Deutsch",
		en: "English",
		es: "Español",
		fr: "Français",
		hi: "हिन्दी",
		ind: "Bahasa Indonesia",
		it: "Italiano",
		ja: "日本語",
		ko: "한국어",
		pt: "Português",
		ru: "Русский",
		tr: "Türkçe",
		vi: "Tiếng Việt",
		zh: "中文",
	},
	$languageLocal: {
		ar: "Tiếng Ả Rập",
		de: "Tiếng Đức",
		en: "Tiếng Anh",
		es: "Tiếng Tây Ban Nha",
		fr: "Tiếng Pháp",
		hi: "Tiếng Hindi",
		ind: "Tiếng Indonesia",
		it: "Tiếng Ý",
		ja: "Tiếng Nhật",
		ko: "Tiếng Hàn",
		pt: "Tiếng Bồ Đào Nha",
		ru: "Tiếng Nga",
		tr: "Tiếng Thổ Nhĩ Kỳ",
		vi: "Tiếng Việt",
		zh: "Tiếng Trung",
	},
	$message: {
		cannot_delete_verified_partner: "Bạn không thể xóa đối tác đã xác minh.",
		confirm: "Bạn có chắc chắn muốn {function}?",
		created: "{item} đã được tạo.",
		deleted: "{item} đã bị xóa.",
		edited: "{item} đã được chỉnh sửa.",
		error_on_view_file: "Đã xảy ra lỗi khi xem tệp.",
		file_oversize: "Kích thước tệp tối đa là {size}.",
		invalid: "{item} không hợp lệ",
		migrated: "{item} đã được chuyển. ({value})",
		process_has_been_started: "Quy trình của bạn {item} đã bắt đầu.",
		saved: "{item} đã được lưu.",
		sent: "{item} đã được gửi.",
		sent_email: "Email đã được gửi. ({value})",
		sign_in_failed: "Email hoặc mật khẩu không chính xác",
		unsupported_file_type: "Loại tệp không được hỗ trợ",
		updated: "{item} đã được cập nhật.",
	},
	$pageDescriptions: {
		landing_page:
			"Antrego - Nền tảng quản lý logistics dành cho nhà xuất khẩu, nhà nhập khẩu & đại lý giao nhận. Theo dõi lô hàng theo thời gian thực, quản lý tồn kho, tạo hóa đơn & tự động hóa chứng từ. Tiết kiệm 40% thời gian với giải pháp logistics số. Dùng thử miễn phí!",
		stock_feature:
			"Biến đổi quản lý tồn kho với Antrego. Quản lý tồn kho, tạo danh mục công khai, theo dõi theo lô trên nhiều kho và chuyển tồn kho thành lô hàng ngay lập tức. Hoàn hảo cho nhà xuất khẩu và nhà sản xuất.",
		tracking_feature:
			"Theo dõi container và lô hàng theo thời gian thực với Antrego. Giám sát mọi container với cập nhật trực tiếp, thông báo tự động, lịch sử trạng thái đầy đủ và hiển thị cho nhiều bên. Không bao giờ mất dấu lô hàng.",
		pdf_feature:
			"Trình tạo tài liệu PDF chuyên nghiệp cho logistics. Thiết kế hóa đơn và báo giá proforma tùy chỉnh với trình kéo thả, mẫu và tự động điền dữ liệu. Tạo tài liệu ấn tượng trong vài phút.",
		benefits_feature:
			"Khám phá các lợi ích của nền tảng Antrego. Bảng điều khiển tập trung, độ chính xác được nâng cao, tiết kiệm thời gian, cộng tác nhóm, giảm chi phí và khả năng mở rộng. Chuyển đổi hoạt động logistics của bạn ngay hôm nay.",
		contact:
			"Liên hệ Antrego - Kết nối với đội ngũ của chúng tôi để đặt câu hỏi, demo hoặc hỗ trợ. Chúng tôi luôn sẵn sàng giúp chuyển đổi hoạt động logistics của bạn.",
		sign_in:
			"Đăng nhập Antrego - Truy cập bảng điều khiển logistics để quản lý lô hàng, theo dõi container, tạo hóa đơn và cộng tác cùng đội ngũ. Cổng đăng nhập an toàn.",
		sign_up:
			"Đăng ký Antrego - Tạo tài khoản miễn phí để bắt đầu quản lý hoạt động logistics. Nhận 10 lô hàng miễn phí mỗi tháng. Không cần thẻ tín dụng để bắt đầu.",
	},
	$pageTitles: {
		accept_invitation: "Chấp nhận lời mời",
		benefits_feature: "Lợi ích của Nền tảng - Giải pháp Logistics Hoàn chỉnh",
		company_profile: "Hồ sơ công ty",
		contact: "Liên hệ - Kết nối với Antrego",
		home: "Trang chủ",
		landing_page: "Quản lý dễ dàng tất cả các quy trình vận chuyển của bạn một cách kỹ thuật số",
		partners: "Đối tác",
		pdf_editor: "Trình chỉnh sửa PDF",
		pdf_feature: "Trình tạo Tài liệu PDF - Hóa đơn Chuyên nghiệp",
		product_details: "Chi tiết Sản phẩm",
		product_groups: "Nhóm sản phẩm",
		products: "Sản phẩm",
		proforma_invoices: "Hóa đơn Proforma",
		shipment_details: "Chi tiết chuyến hàng",
		shipments: "Chuyến hàng",
		sign_in: "Đăng nhập",
		sign_up: "Đăng ký",
		stock_details: "Chi Tiết Hàng Tồn Kho",
		stock_feature: "Quản lý Tồn kho - Biến đổi Hàng hóa của bạn",
		stocks: "Hàng Tồn Kho",
		subscription: "Đăng ký",
		tracking_feature: "Theo dõi Lô hàng - Giám sát Container theo Thời gian thực",
		user_profile: "Hồ sơ người dùng",
	},
	$partnershipStatusTooltip: {
		createdHereDescription:
			"Không phải đối tác đã đăng ký, bạn đã tạo hồ sơ của họ trên nền tảng của chúng tôi để bạn có thể xem và chỉnh sửa thông tin của họ.",
		createdHereTitle: "Được tạo tại đây:",
		description: "Bạn có thể theo dõi trạng thái mối quan hệ của mình với các đối tác. Đây là những khác biệt:",
		verifiedPartnersDescription:
			"Các đối tác này đã chấp nhận lời mời của bạn và đăng ký trên nền tảng. Thông tin của họ chỉ có thể xem và không thể chỉnh sửa.",
		verifiedPartnersTitle: "Đối tác đã xác minh:",
	},
	$productGroup: {
		add_child: "Thêm nhóm con",
		add_new_product_group: "Thêm nhóm sản phẩm mới",
		add_to_root: "Thêm vào gốc",
		has_children_fail_message: "Một nhóm sản phẩm có nhóm con không thể bị xóa",
		initial_message: "Sử dụng nút {0} này để tạo nhóm sản phẩm đầu tiên của bạn.",
		name: "Tên nhóm sản phẩm",
		number_of_product: "Số lượng sản phẩm",
	},
	$proformaInvoice: {
		$actionDescription: {
			approve: "{name} đã được phê duyệt.",
			create: "Được tạo bởi {name}.",
			create_attachment: "{name} đã tạo tệp đính kèm.",
			delete_attachment: "{name} đã xóa tệp đính kèm.",
			demand_revise: "{name} đã yêu cầu sửa đổi.",
			mark_as_processed: "{name} được đánh dấu là đã xử lý.",
			reject: "{name} đã bị từ chối.",
			revoke: "{name} đã bị hủy.",
			send: "{name} đã gửi cho người nhận để đánh giá.",
			update: "Được cập nhật bởi {name}.",
			update_attachment: "{name} đã cập nhật tệp đính kèm.",
		},
		$actions: {
			approve: "Phê duyệt",
			demand_revise: "Yêu cầu sửa đổi",
			mark_as_approved: "Đã phê duyệt",
			mark_as_processed: "Đã xử lý",
			mark_as_rejected: "Đã từ chối",
			mark_as_revise_demanded: "Yêu cầu sửa đổi",
			mark_as_revoked: "Đã hủy",
			mark_as_sent: "Đã gửi",
			reject: "Từ chối",
			revoke: "Hủy",
			send: "Gửi",
		},
		$status: {
			approved: "Đã phê duyệt",
			pending_approval: "Đang chờ phê duyệt",
			pending_revise: "Đang chờ sửa đổi",
			processed: "Đã xử lý",
			rejected: "Đã từ chối",
			revoked: "Đã hủy",
			template: "Mẫu",
		},
		approve_confirm_message: "Bạn có chắc chắn muốn phê duyệt hóa đơn proforma không?",
		approve_success_message: "Hóa đơn proforma đã được phê duyệt.",
		demand_revise_description_message: "Vui lòng cung cấp chi tiết về kỳ vọng sửa đổi của bạn:",
		demand_revise_success_message: "Hóa đơn proforma đã được gửi lại cho người gửi để sửa đổi.",
		mark_as_processed_confirm_message: "Bạn có xác nhận đánh dấu hóa đơn proforma là đã xử lý không?",
		mark_as_processed_success_message: "Hóa đơn proforma đã được đánh dấu là đã xử lý.",
		no_attachment_text: "Chưa có tệp đính kèm nào được thêm.",
		reject_confirm_message: "Bạn có chắc chắn muốn từ chối hóa đơn proforma không?",
		reject_success_message: "Hóa đơn proforma đã bị từ chối.",
		revoke_confirm_message: "Bạn có chắc chắn muốn hủy hóa đơn proforma không?",
		revoke_success_message: "Hóa đơn proforma đã bị hủy.",
		send_confirm_message: "Bạn có xác nhận gửi hóa đơn proforma cho người nhận không?",
		send_success_message: "Hóa đơn proforma đã được gửi.",
	},
	$seoTitles: {
		landing_page: "Antrego | Phần mềm quản lý logistics - Theo dõi, Quản lý, Tự động hóa",
		stock_feature: "Phần mềm quản lý tồn kho | Hệ thống theo dõi tồn kho | Antrego",
		tracking_feature: "Phần mềm theo dõi lô hàng thời gian thực | Theo dõi container | Antrego",
		pdf_feature: "Trình tạo hóa đơn Proforma | Trình chỉnh sửa PDF cho logistics | Antrego",
		benefits_feature: "Lợi ích của nền tảng logistics toàn diện | Giải pháp all-in-one | Antrego",
	},
	$serviceMessage: {
		already_subs_module: "Đã có đăng ký cho mô-đun này.",
		bad_request: "Yêu cầu không hợp lệ",
		code_already_used: "Mã đã được sử dụng.",
		container_status_not_available: "Trạng thái container không khả dụng.",
		existing_email_warning: "Email đã tồn tại.",
		existing_employee_error: "Người dùng này đã được thêm vào công ty của bạn.",
		existing_employee_for_email_warning: "Mã mời đã được gửi đến email này",
		existing_invitation_warning: "Mã mời đã được gửi đến email này.",
		existing_token_already_have_time: "Mã token hiện tại đã có đủ thời gian để sử dụng.",
		existing_user: "Người dùng đã tồn tại.",
		five_min_reset_password_mail: "Bạn phải đợi ít nhất 5 phút sau khi yêu cầu một email đặt lại mật khẩu.",
		forbidden: "Cấm",
		have_no_corporation: "Bạn không có công ty",
		have_no_custom_agency: "Bạn không có cơ quan hải quan",
		have_no_employee: "Bạn không có nhân viên",
		instance_can_no_delete_existing_booking_code: "Không thể xóa thực thể này do mã đặt chỗ hiện có.",
		instance_cannot_delete: "Không thể xóa thực thể này.",
		instance_not_found: "Không tìm thấy thực thể.",
		internal_server_error: "Lỗi máy chủ nội bộ",
		invalid_current_password: "Mật khẩu hiện tại không hợp lệ.",
		invalid_identifier_or_password: "Nhận dạng hoặc mật khẩu không hợp lệ",
		invalid_invitation_code: "Mã mời không chính xác.",
		invalid_moving_request: "Yêu cầu di chuyển không hợp lệ",
		invalid_operation: "Hoạt động không hợp lệ",
		invalid_refresh_token: "Mã làm mới không hợp lệ.",
		invalid_unit: "Đơn vị không hợp lệ",
		invitation_accepting_is_due_to_the_admin: "Chấp nhận lời mời tùy thuộc vào quản trị viên.",
		invitation_already_discarded: "Lời mời đã bị từ chối.",
		invitation_already_used: "Lời mời đã được sử dụng.",
		invitation_has_been_used: "Lời mời đã được sử dụng.",
		invitation_not_exist_email: "Không tồn tại lời mời email này.",
		invitation_not_for_company: "Lời mời này không dành cho công ty.",
		invitation_not_for_custom_agency: "Lời mời này không dành cho cơ quan hải quan.",
		invitation_not_found: "Không tìm thấy lời mời.",
		invitation_not_valid: "Lời mời này không còn hiệu lực.",
		link_has_been_expired: "Liên kết đã hết hạn.",
		link_not_be_used_anymore: "Liên kết này không thể được sử dụng nữa",
		missing_required_fields: "Thiếu các trường bắt buộc.",
		no_employee_found: "Không tìm thấy nhân viên",
		no_proper_partner_found: "Không tìm thấy đối tác thích hợp.",
		not_acceptable: "Không chấp nhận được",
		not_allowed_action: "Bạn không được phép thực hiện hành động này.",
		not_allowed_use_api: "Bạn không được phép sử dụng API này.",
		not_found: "Không tìm thấy",
		not_have_purchase_subscription:
			"Gói đăng ký của bạn đã đạt đến giới hạn tối đa cho các mục. Để thêm nhiều hơn, vui lòng xem xét nâng cấp gói đăng ký của bạn.",
		not_permitted_use_api: "Bạn không được phép sử dụng API này.",
		own_invitation_cannot_accept: "Bạn không thể chấp nhận lời mời của chính mình.",
		parent_group_not_found: "Không tìm thấy nhóm cha",
		partnerId_required: "Yêu cầu ID đối tác.",
		partnership_already_exists: "Đối tác đã được thêm vào.",
		password_cant_involve_space_char: "Mật khẩu không được chứa khoảng trắng.",
		password_min_chars_least: "Mật khẩu phải có ít nhất 6 ký tự.",
		payment_required: "Vui lòng đăng ký cho quy trình này.",
		paytr_integration_error: "Lỗi tích hợp PayTR",
		ports_are_required: "Cần có cổng.",
		product_group_tree_not_found: "Không tìm thấy cây nhóm sản phẩm",
		proforma_invoice_action_not_available: "Trạng thái hóa đơn proforma không khả dụng cho hành động này.",
		proforma_invoice_template_update: "Hóa đơn proforma phải là mẫu để được cập nhật.",
		shipment_email_not_exist: "Vui lòng nhập email hợp lệ.",
		shipment_method_is_required: "Cần có phương thức giao hàng.",
		shipping_term_is_required: "Cần có điều kiện vận chuyển.",
		someone_else_uses_this_email: "Người khác đang sử dụng địa chỉ email này.",
		someone_else_uses_this_username: "Người khác đang sử dụng tên người dùng này.",
		something_went_wrong: "Đã xảy ra lỗi",
		type_can_be_abstract_company: 'Thuộc tính "loại" chỉ có thể là "abstract_company"',
		unauthorized: "Không có quyền",
		undefined_result: "Kết quả không xác định",
		unexpected_error_occurred: "Đã xảy ra lỗi bất ngờ",
		unit_already_added: "Đơn vị đã được thêm.",
		user_already_employee: "Người dùng đã là nhân viên.",
		user_already_exists: "Người dùng đã tồn tại trong công ty.",
		user_does_not_exist: "Người dùng không tồn tại.",
		user_not_found: "Không tìm thấy người dùng.",
		username_min_chars_error: "Tên người dùng phải có ít nhất 6 ký tự.",
	},
	$shipment: {
		$actionDescription: {
			$land: {
				create_container: "{name} đã thêm một phương tiện.",
				delete_container: "{name} đã xóa một phương tiện.",
				update_container: "{name} đã cập nhật một phương tiện.",
			},
			create: "Được tạo bởi {name}.",
			create_attachment: "{name} đã thêm một tệp đính kèm.",
			create_container: "{name} đã thêm một container.",
			delete_attachment: "{name} đã xóa một tệp đính kèm.",
			delete_container: "{name} đã xóa một container.",
			update: "Được cập nhật bởi {name}.",
			update_attachment: "{name} đã cập nhật tệp đính kèm.",
			update_container: "{name} đã cập nhật container.",
		},
		$containerStatus: {
			arrived: "Đã đến",
			off_load: "Đã dỡ hàng",
			on_load: "Đang tải",
			on_way: "Đang trên đường",
			reserved: "Đã đặt chỗ",
		},
		$method: {
			aerial: "Đường hàng không",
			land: "Đường bộ",
			railway: "Đường sắt",
			sea: "Đường biển",
		},
		$vehicle: {
			license_number: "Biển số xe",
		},
		archiving_success_message: "Chuyến hàng đã được lưu trữ.",
		leave_message: "Để lại tin nhắn hoặc bình luận của bạn",
		no_booking_info: "Chưa có thông tin đặt chỗ. Sử dụng nút {0} để thêm.",
		no_transportation_info: "Chưa có thông tin chi tiết. Sử dụng nút {0} để thiết lập.",
		un_archiving_success_message: "Chuyến hàng đã được khôi phục.",
	},
	$shortening: {
		number: "Số",
	},
	$socialMedia: {
		facebook: "Facebook",
		instagram: "Instagram",
		linked_in: "LinkedIn",
		twitter: "Twitter",
	},
	$subscription: {
		$message: {
			check_your_payment_method: "Không thể gia hạn đăng ký của bạn. Vui lòng kiểm tra phương thức thanh toán của bạn.",
			fail: "Đã xảy ra lỗi không mong muốn. Vui lòng thử lại sau. Nếu vấn đề vẫn tiếp diễn, vui lòng báo cáo bằng cách gửi email đến info@antrego.net.",
			ok: "Quá trình mua hàng đã được bắt đầu. Kết quả của quá trình sẽ được thông báo qua email. Đăng ký của bạn sẽ bắt đầu khi thanh toán thành công.",
			payment_process_is_ongoing:
				"Quá trình thanh toán của bạn đang tiếp diễn. Kết quả của quá trình sẽ được thông báo qua email. Đăng ký của bạn sẽ bắt đầu khi thanh toán thành công.",
			success: "Đăng ký của bạn đã được tạo thành công. Bạn có thể bắt đầu sử dụng Antrego dễ dàng.",
			try_to_get_paid_again: "Đăng ký của bạn đã hết hạn. Nhấp vào đây để gia hạn.",
			unsubscribed: "Đã hủy đăng ký",
			you_dont_have_any_subscription:
				"Bạn không có bất kỳ đăng ký nào. Vui lòng chọn một gói trên trang đăng ký và bắt đầu sử dụng dễ dàng.",
			you_dont_have_any_subscription_text: "Vui lòng chọn gói để tiếp tục.",
			you_dont_have_any_subscription_title: "Bạn không có đăng ký nào.",
		},
	},
	$unit: {
		acres: "Acre",
		boxes: "Hộp",
		centimeter: "Xăng-ti-mét",
		cubic_meter: "Mét khối",
		dozen: "Tá",
		feet: "Feet",
		fluid_ounces: "Ounce chất lỏng",
		gallons: "Gallon",
		gram: "Gam",
		hectare: "Hecta",
		inches: "Inch",
		kilogram: "Kilôgam",
		kilometer: "Kilômét",
		liter: "Lít",
		meter: "Mét",
		miles: "Dặm",
		milligram: "Miligram",
		milliliter: "Mililit",
		millimeter: "Milimét",
		ounces: "Ounce",
		pallets: "Pallet",
		pieces: "Miếng",
		pounds: "Pound",
		quarts: "Quart",
		square_feet: "Feet vuông",
		square_inches: "Inch vuông",
		square_kilometer: "Kilômét vuông",
		square_meter: "Mét vuông",
		square_miles: "Dặm vuông",
		square_yards: "Yard vuông",
		ton: "Tấn",
		yards: "Yard",
	},
	$validation: {
		email: "Vui lòng nhập email hợp lệ",
		invalid: "{item} không hợp lệ",
		max_length: "{item} phải nhỏ hơn {length} ký tự",
		min_length: "{item} phải lớn hơn {length} ký tự",
		must_length: "{item} phải có {length} ký tự",
		only_number: "{item} phải là số",
		password_repeat_warning: "Lặp lại mật khẩu không giống với mật khẩu mới.",
		required: "{item} là bắt buộc",
		required_for_default_language: "{item} là bắt buộc cho ngôn ngữ mặc định của công ty.",
		you_must_approve_distance_sales_agreement: "Bạn phải chấp nhận Hợp đồng Bán hàng từ xa",
	},
	about: "Về chúng tôi",
	accept_invitation: "Chấp nhận lời mời",
	accept_invitation_success_message: "Bạn đã sử dụng lời mời thành công.",
	accessibility: "khả năng tiếp cận",
	actions: "Hành động",
	active: "Hoạt động",
	activities: "Hoạt động",
	add: "Thêm",
	add_attribute: "Thêm Thuộc tính",
	add_from_stock: "Thêm từ kho",
	add_images: "Thêm Hình Ảnh",
	add_item: "Thêm {item}",
	add_manually: "Tạo tại đây",
	add_new_employee: "Thêm nhân viên mới",
	add_new_packaging: "Thêm bao bì mới",
	add_new_product: "Thêm sản phẩm mới",
	add_new_stock: "Thêm Hàng Tồn Kho Mới",
	add_new_warehouse: "Thêm kho mới",
	add_stock_batch: "Thêm Lô Hàng Tồn Kho",
	add_template: "Thêm mẫu",
	add_variant: "Thêm Biến thể",
	address: "Địa chỉ",
	again: "Lại",
	alert: "Cảnh báo",
	already_have_employee_message: "Bạn đã là nhân viên của một công ty.",
	amount: "Số lượng",
	approve: "Phê duyệt",
	archive: "Lưu trữ",
	attachment: "Tệp đính kèm",
	attachments: "Các tệp đính kèm",
	attribute: "Thuộc tính",
	attributes: "Thuộc tính",
	auto_attached_pdf: "PDF được đính kèm tự động",
	auto_detect: "Tự động phát hiện",
	available: "Có sẵn",
	bank: "Ngân hàng",
	basket: "Giỏ hàng",
	basket_empty: "Giỏ hàng của bạn trống",
	batch: "Lô hàng",
	batch_no: "Số Lô",
	batches: "Lô Hàng Tồn Kho",
	benefits: "Lợi ích",
	billed_to: "Tính tiền cho",
	booking: "Đặt chỗ",
	booking_code: "Mã đặt chỗ",
	booking_details: "Chi tiết đặt chỗ",
	boolean: "Boolean",
	business_partner: "Đối tác kinh doanh",
	business_partners: "Các đối tác kinh doanh",
	cancel: "Hủy",
	carrier: "Nhà vận chuyển",
	change_password: "Đổi mật khẩu",
	checking_invitation_code_message: "Đang kiểm tra mã mời",
	checkout: "Thanh toán",
	choose_image: "Chọn hình ảnh",
	choose_your_plan: "Chọn gói của bạn",
	clear: "Xóa",
	clear_basket: "Xóa giỏ hàng",
	click_to_play_the_video: "Nhấn để phát video",
	close: "Đóng",
	code: "Mã",
	commercial: "Thương mại",
	commercial_partner: "Đối tác thương mại",
	commercial_partners: "Các đối tác thương mại",
	companies: "Các công ty",
	company: "Công ty",
	company_address: "Địa chỉ công ty",
	company_name: "Tên công ty",
	company_profile: "Hồ sơ công ty",
	configuration: "Cấu hình",
	confirm: "Xác nhận",
	confirm_distance_selling_agreement: "Xác nhận Hợp đồng Bán hàng từ xa.",
	consult_us: "Tham khảo ý kiến ​​chúng tôi",
	contact: "Liên hệ",
	contact_info: "Thông tin liên hệ",
	contact_text: "Đừng lo lắng, chúng tôi sẽ liên hệ với bạn sớm nhất có thể.",
	contact_title: "Liên hệ với chúng tôi, đơn giản hóa quy trình của bạn",
	contact_to_us: "Liên hệ với chúng tôi",
	container: "Container",
	container_no: "Số container",
	containers: "Các container",
	content: "Nội dung",
	contract: "Hợp đồng",
	copy_link: "Sao chép liên kết",
	corporation: "Công ty",
	countries: "Các quốc gia",
	country: "Quốc gia",
	create: "Tạo",
	create_a_new_account: "Tạo tài khoản mới",
	create_company: "Tạo công ty",
	create_document: "Tạo tài liệu",
	create_shipment: "Tạo lô hàng",
	created_at: "Được tạo lúc",
	created_here: "Được tạo ở đây",
	credit_card_info: "Thông tin thẻ tín dụng",
	credit_card_no: "Số thẻ tín dụng",
	currencies: "Các loại tiền tệ",
	currency: "Tiền tệ",
	current_password: "Mật khẩu hiện tại",
	current_plan: "Gói hiện tại",
	customer_company_address: "Địa chỉ công ty khách hàng",
	customer_company_name: "Tên công ty khách hàng",
	customs: "Hải quan",
	customs_agencies: "Các cơ quan hải quan",
	customs_agency: "Cơ quan hải quan",
	cvv: "CVV",
	daily: "Hàng ngày",
	damaged: "Hư Hỏng",
	dashboard: "Bảng điều khiển",
	date: "Ngày",
	date_input: "Nhập ngày",
	day: "Ngày",
	default: "Mặc định",
	default_language: "Ngôn ngữ mặc định",
	delete: "Xóa",
	delete_account: "Xóa tài khoản",
	delete_confirm_message: "Bạn có xác nhận xóa không?",
	delete_document: "Xóa tài liệu",
	delete_template: "Xóa mẫu",
	description: "Mô tả",
	detail: "Chi tiết",
	dimensions: "Kích thước",
	discard: "Hủy bỏ",
	discover_all_benefits: "Khám phá mọi lợi ích",
	distance_sales_agreement: "Hợp đồng Bán hàng từ xa",
	document: "Tài liệu",
	document_actions: "Hành động tài liệu",
	document_added: "Tài liệu đã được thêm",
	document_creator: "Trình tạo tài liệu",
	document_manager: "Quản lý tài liệu",
	document_name: "Tên tài liệu",
	document_number: "Số tài liệu",
	document_overwrite: "Lưu chỉnh sửa làm tài liệu mới",
	document_save_info: "Tài liệu này sẽ chỉ được lưu trong hóa đơn tạm này.",
	document_updated: "Tài liệu đã được cập nhật",
	download: "Tải xuống",
	download_pdf: "Tải xuống PDF",
	download_template: "Tải mẫu",
	edit: "Chỉnh sửa",
	edit_attribute: "Chỉnh sửa thuộc tính",
	edit_description: "Chỉnh sửa mô tả",
	edit_document: "Chỉnh sửa tài liệu",
	edit_item: "Chỉnh sửa {item}",
	edit_packaging: "Chỉnh sửa bao bì",
	edit_product: "Chỉnh sửa sản phẩm",
	edit_profile: "Chỉnh sửa hồ sơ",
	edit_stock: "Chỉnh sửa hàng tồn kho",
	edit_stock_batch: "Chỉnh Sửa Lô Hàng Tồn Kho",
	edit_template: "Chỉnh sửa mẫu",
	edit_variant: "Chỉnh Sửa Biến Thể",
	edit_your_profile_picture: "Chỉnh sửa ảnh hồ sơ",
	email: "Email",
	employee: "Nhân viên",
	employee_type: "Loại nhân viên",
	employees: "Các nhân viên",
	empty_data_warning: "Vùng này chưa có dữ liệu nào. Bạn có thể bắt đầu khám phá nền tảng với dữ liệu mẫu.",
	estimated_arrival_day: "Ngày đến dự kiến",
	expense: "Chi phí",
	expenses: "Các chi phí",
	expires_at: "Hết hạn vào",
	explore_pdf_editor: "Tạo tài liệu ngay lập tức",
	explore_stock_management: "Làm chủ Tồn kho của bạn",
	explore_tracking_features: "Theo dõi theo Thời gian thực",
	exported_containers: "Các container đã xuất",
	fail: "Thất bại",
	failed: "Đã thất bại",
	faq: "Câu hỏi thường gặp",
	feedback: "Phản hồi",
	file: "Tệp",
	file_name: "Tên tệp",
	file_preview: "Xem trước tệp",
	file_processing_error_message: "Lỗi xử lý tệp: {error}",
	file_read_error_message: "Lỗi đọc tệp",
	file_view: "Xem tệp",
	filter: "Bộ lọc",
	first_name: "Tên",
	first_name_last_name: "Họ và tên",
	fixed_value: "Giá trị cố định",
	forget_password: "Quên mật khẩu",
	forget_password_message: "Bạn đã quên mật khẩu?",
	forget_password_subtitle: "Vui lòng nhập địa chỉ email của bạn để đặt lại mật khẩu.",
	format: "Định dạng",
	free: "Miễn phí",
	from: "Từ",
	general: "Mặc định",
	get_started_now: "Bắt đầu ngay",
	give_us_feedback: "Đưa cho chúng tôi phản hồi",
	go_to_panel: "Đi đến bảng điều khiển",
	go_to_proforma: "Đi đến hóa đơn proforma",
	go_to_shipment: "Đi đến lô hàng",
	gross: "Tổng",
	height: "Chiều cao",
	hide: "Ẩn",
	hide_all: "Ẩn Tất cả",
	home_page: "Trang chủ",
	i_have_invitation_code: "Tôi có mã mời",
	image_delete: "Xóa ảnh",
	images: "Hình Ảnh",
	import_excel: "Nhập từ Excel",
	import_fail_message: "Nhập khẩu thất bại: {error}",
	import_success_message: "Nhập thành công {count} sản phẩm{skipped}.",
	imported_containers: "Các container đã nhập",
	in_progress: "Đang tiến hành",
	in_stock: "Còn Hàng",
	incoming: "Đang đến",
	incoming_shipments: "Các chuyến hàng đang đến",
	initial: "Ban đầu",
	inputs: "Nội dung",
	invitation: "Lời mời",
	invitation_code: "Mã mời",
	invitation_mail_sent: "Email mời đã được gửi",
	invitations: "Các lời mời",
	invoice: "Hóa đơn",
	invoice_no: "Số hóa đơn",
	join: "Tham gia",
	join_company: "Tham gia công ty",
	language: "Ngôn ngữ",
	language_options: "Tùy chọn ngôn ngữ",
	last_name: "Họ",
	last_one_year: "Năm vừa qua",
	latitude: "Vĩ độ",
	learn_more: "Tìm hiểu thêm",
	left_a_comment: "Đã để lại một bình luận",
	length: "Chiều dài",
	link_copied: "Liên kết đã được sao chép",
	link_copy_failed: "Sao chép liên kết thất bại",
	loading_country: "Quốc gia xuất hàng",
	loading_point: "Điểm xuất hàng",
	loading_port: "Cảng xuất hàng",
	log_in: "Đăng nhập",
	logo: "Logo",
	longitude: "Kinh độ",
	lot_no: "Số Lô",
	mail_sent: "Email đã được gửi",
	make_visible: "Làm Cho Hiển Thị",
	manage_profile: "Quản lý hồ sơ",
	mass: "Khối lượng",
	measurements: "Kích thước",
	merge_partner_description:
		"Công ty được tạo ở đây có thể được hợp nhất với đối tác đã xác minh hiện có khi nó tạo hồ sơ trên Antrego.",
	message: "Tin nhắn",
	message_company_create: "Công ty đã được tạo.",
	message_company_join: "Vui lòng nhập mã lời mời.",
	message_company_joined: "Bạn đã tham gia công ty",
	message_employee_delete: "Nhân viên đã bị xóa.",
	message_employee_save: "Nhân viên đã được lưu.",
	message_join_company: "Nhập mã của bạn để tham gia công ty hiện có",
	method: "Phương pháp",
	migrate: "Di chuyển",
	migrate_partner: "Di chuyển công ty",
	migrate_partner_description:
		"Công ty được tạo ở đây có thể được hợp nhất với đối tác đã được xác minh hiện có khi họ tạo hồ sơ trên Antrego.",
	missing_product_group_sheet_message: "Thiếu bảng Nhóm sản phẩm trong tệp Excel",
	missing_product_sheet_message: "Thiếu bảng Sản phẩm trong tệp Excel",
	mobile_number: "Số di động",
	month: "Tháng",
	month_lowercase: "tháng",
	monthly: "Hàng tháng",
	multiple_select: "Chọn nhiều",
	my_profile: "Hồ sơ của tôi",
	my_role: "Vai trò của tôi",
	name: "Tên",
	net: "Tịnh",
	new: "Mới",
	new_company_package: "Miễn phí",
	new_password: "Mật khẩu mới",
	new_shipment: "Chuyến hàng mới",
	next: "Tiếp theo",
	no: "Không",
	no_content: "Không có nội dung",
	no_entity: "Không có thực thể",
	no_entity_message: "Không tìm thấy thực thể.",
	no_image: "Không tìm thấy hình ảnh",
	no_product_data_message: "Không tìm thấy dữ liệu sản phẩm trong tệp Excel",
	no_product_group_data_message: "Không tìm thấy dữ liệu nhóm sản phẩm trong tệp Excel",
	no_stock_batches_found: "Không tìm thấy lô hàng tồn kho",
	no_stock_matches_filters: "Không có hàng tồn kho nào phù hợp với bộ lọc đã chọn.",
	no_stocks_added_yet: "Chưa có hàng tồn kho nào được thêm — vui lòng chọn hoặc thêm một.",
	no_text: "Không có văn bản",
	no_valid_products_message:
		"Không tìm thấy sản phẩm hợp lệ. Tất cả sản phẩm phải có tên bằng ngôn ngữ mặc định ({language}).",
	not_found_in_stock: "Không tìm thấy sản phẩm trong kho với bộ lọc hiện tại.",
	not_found_page_message: "Xin lỗi, tôi không thể tìm thấy trang này :(",
	not_set: "Chưa đặt",
	note: "Ghi chú",
	notes: "Ghi chú",
	number_of_rows: "Số hàng",
	ok: "OK",
	operation_fail: "Thất bại thao tác",
	option: "Tùy chọn",
	options: "Tùy chọn",
	other: "Khác",
	out_of_stock: "Hết Hàng",
	outgoing: "Đang gửi",
	outgoing_shipments: "Các chuyến hàng đang gửi",
	packages: "Các gói",
	packaging: "Bao bì",
	packing_list_title: "Danh sách đóng gói",
	parent_group: "Nhóm cha",
	partner: "Đối tác",
	partners: "Các đối tác",
	partnership_status: "Trạng thái hợp tác",
	passive: "Thụ động",
	password: "Mật khẩu",
	pay: "Thanh toán",
	payback: "Hoàn trả",
	payback_confirm_message: "Bạn có xác nhận hoàn trả không?",
	payback_warning_message: "Nếu bạn tiếp tục, đăng ký của bạn sẽ bị hủy.",
	payment: "Thanh toán",
	payment_amount: "Số tiền thanh toán",
	payment_awaited: "Đang chờ thanh toán",
	payment_history: "Lịch sử thanh toán",
	payment_info: "Thông tin thanh toán",
	payment_information: "Thông tin thanh toán",
	payment_success: "Thanh toán thành công",
	payment_summary: "Tóm tắt thanh toán",
	payment_will_be_made_3d_secure: "*Thanh toán của bạn sẽ được thực hiện bằng 3D Secure.",
	pdf_attached_message: "PDF đã được đính kèm thành công",
	pdf_editor: "Trình chỉnh sửa PDF",
	pdf_name: "Tên PDF",
	pending_invitations: "Lời mời đang chờ xử lý",
	per_month: "Mỗi tháng",
	phone_number: "Số điện thoại",
	pieces: "Mảnh",
	plate_numbers: "Biển số xe",
	please_click_add_option: "Bạn đã nhập một tùy chọn nhưng chưa thêm nó. Vui lòng thêm hoặc xóa.",
	prefix: "Tiền tố",
	premium: "Cao cấp",
	premium_plus: "Cao cấp Plus",
	preview: "Xem trước",
	previous: "Trước",
	price: "Giá",
	pricing: "Giá cả",
	process: "Quy trình",
	product: "Sản phẩm",
	product_details: "Chi tiết Sản phẩm",
	product_group: "Nhóm sản phẩm",
	product_group_name: "Tên nhóm sản phẩm",
	product_group_not_found_message: 'Không tìm thấy nhóm sản phẩm "{group}". Bỏ qua sản phẩm có mã "{code}".',
	product_groups: "Các nhóm sản phẩm",
	product_images: "Hình ảnh sản phẩm",
	product_name: "Tên sản phẩm",
	products: "Các sản phẩm",
	profile: "Hồ sơ",
	proforma_invoice: "Hóa đơn Proforma",
	proforma_invoices: "Các hóa đơn Proforma",
	proforma_number: "Số hóa đơn Proforma",
	proforma_options: "Tùy chọn Hóa đơn",
	proforma_title: "Hóa đơn nháp",
	purchase: "Mua",
	quantity: "Số lượng",
	quantity_warning: "Vì bạn đã thay đổi giá trị Tổng kho trước đó, tổng số sẽ không được tính tự động.",
	ready_to_import: "Sẵn sàng nhập",
	receiver: "Người nhận",
	receiver_company: "Công ty người nhận",
	receiver_customs_agency: "Cơ quan hải quan người nhận",
	redirection_to_home_link: "Trang chủ",
	redirection_to_home_message: "Bạn cũng có thể chuyển đến ",
	redirection_to_sign_in_message: "Bạn đã có tài khoản?",
	redirection_to_sign_up_message: "Bạn chưa có tài khoản?",
	reload: "Tải lại",
	renewal: "Gia hạn",
	repaid: "Đã hoàn trả",
	reserved: "Đã Đặt Trước",
	reset_password: "Đặt lại mật khẩu",
	returned: "Đã Trả Hàng",
	route: "Lộ trình",
	rows_per_page: "Hàng mỗi trang",
	sales: "Bán hàng",
	save: "Lưu",
	save_as_document: "Lưu làm tài liệu",
	save_as_new_document: "Lưu dưới dạng tài liệu mới",
	save_as_new_template: "Lưu dưới dạng mẫu mới",
	save_as_template: "Lưu làm mẫu",
	save_changes: "Lưu thay đổi",
	save_pdf_to_attachments: "Lưu PDF vào tệp đính kèm",
	saved_card_info: "Thông tin thẻ đã lưu",
	search: "Tìm kiếm",
	select: "Chọn",
	select_a_file_to_preview: "Chọn tệp để xem trước",
	select_document: "Chọn tài liệu",
	select_document_to_overwrite: "Chọn tài liệu để ghi đè",
	select_file: "Chọn tệp",
	select_file_place_holder: "Vui lòng chọn một hình ảnh",
	select_language: "Chọn ngôn ngữ",
	select_template: "Chọn mẫu",
	select_template_to_overwrite: "Chọn mẫu để ghi đè",
	selected: "Đã chọn",
	selected_partner: "Đối tác được chọn",
	send: "Gửi",
	send_again: "Gửi lại",
	send_email: "Gửi email",
	send_feedback: "Gửi phản hồi",
	send_invitation: "Gửi lời mời",
	sender: "Người gửi",
	sender_company: "Công ty người gửi",
	sender_customs_agency: "Cơ quan hải quan người gửi",
	separate_gross: "Thêm kích thước tổng",
	settings: "Cài đặt",
	shipment: "Chuyến hàng",
	shipment_code: "Mã lô hàng",
	shipment_details: "Chi tiết lô hàng",
	shipment_method: "Phương thức vận chuyển",
	shipment_type: "Loại chuyến hàng",
	shipments: "Các chuyến hàng",
	shipments_filter: "Bộ lọc chuyến hàng",
	shipped: "Đã Giao Hàng",
	shipping_term: "Điều kiện giao hàng",
	shipping_terms: "Các điều kiện giao hàng",
	show: "Hiển thị",
	show_all: "Hiển thị Tất cả",
	show_company_stock_page: "Hiển Thị Trang Tồn Kho Công Ty",
	show_in_stocks: "Hiển thị trên Trang Kho",
	sign_in: "Đăng nhập",
	sign_out: "Đăng xuất",
	sign_out_confirm_message: "Bạn có xác nhận đăng xuất không?",
	sign_out_success_message: "Tạm biệt.",
	sign_up: "Đăng ký",
	sizes: "Kích Thước",
	social_media: "Mạng xã hội",
	social_media_account: "Tài khoản mạng xã hội",
	start_time: "Thời gian bắt đầu",
	status: "Trạng thái",
	stock: "Hàng tồn kho",
	stock_details: "Chi Tiết Hàng Tồn Kho",
	stock_images: "Hình Ảnh Hàng Tồn Kho",
	stock_status: "Tình Trạng Hàng Tồn Kho",
	stocks: "Hàng Tồn Kho",
	stocks_url: "Liên kết Kho",
	subscribe: "Đăng ký",
	subscription: "Đăng ký",
	subscription_info_message: "Bạn có thể sử dụng tất cả các dịch vụ không giới hạn trong thời gian đăng ký.",
	subscription_warning_message:
		"**Thông tin thẻ của bạn sẽ được lưu trữ an toàn và đăng ký của bạn sẽ được gia hạn thường xuyên trừ khi bạn hủy.",
	success: "Thành công",
	super: "Siêu",
	supported_files_img: "Các tệp được hỗ trợ: JPG, PNG.",
	switch_language: "Chuyển ngôn ngữ",
	switch_theme: "Chuyển chủ đề",
	table_inputs: "Nội dung bảng",
	target: "Mục tiêu",
	target_partner: "Đối tác mục tiêu",
	tax_number: "Mã số thuế",
	template: "Mẫu",
	template_actions: "Hành động mẫu",
	template_added: "Mẫu đã được thêm",
	template_name: "Tên mẫu",
	template_overwrite: "Lưu chỉnh sửa làm mẫu mới",
	template_save_info: "Mẫu đã lưu sẽ được sử dụng sau trong hóa đơn tạm và vận chuyển.",
	template_updated: "Mẫu đã được cập nhật",
	terms_of_sale_and_other_comments: "Điều khoản bán hàng - Bình luận",
	text_input: "Nhập văn bản",
	theme: "Chủ đề",
	this_month: "Tháng này",
	this_year: "Năm nay",
	title: "Tiêu đề",
	to: "Đến",
	toDelete: "Xóa",
	total: "Tổng cộng",
	total_amount: "Tổng số tiền",
	total_price: "Tổng Giá",
	total_warning: "Nếu bạn thay đổi dữ liệu này, tổng số sẽ không còn được tính tự động.",
	tracking: "Theo dõi Lô hàng",
	transaction_no: "Số giao dịch",
	transactions: "Giao dịch",
	try_for_free: "Dùng thử miễn phí",
	type: "Loại",
	types: "Các loại",
	un_archive: "Bỏ lưu trữ",
	unit: "Đơn vị",
	unit_price: "Đơn giá",
	units: "Các đơn vị",
	unloading_country: "Quốc gia dỡ hàng",
	unloading_point: "Điểm dỡ hàng",
	unloading_port: "Cảng dỡ hàng",
	unsubscribe: "Hủy đăng ký",
	unsubscribe_confirm_message:
		"Nếu bạn hủy đăng ký, bạn sẽ không thể sử dụng các tính năng của hệ thống một cách hiệu quả. Bạn có chắc chắn muốn hủy đăng ký không?",
	upload_new_image: "Tải ảnh mới",
	use_code: "Sử dụng mã",
	use_invitation_code: "Sử dụng mã mời",
	use_invitation_code_description: "Nhập mã mời của bạn đã gửi vào hộp thư của bạn.",
	use_invitation_code_success_message: "Mã mời đã được sử dụng thành công.",
	user_profile: "Hồ sơ của tôi",
	value: "Giá trị",
	variant: "Biến thể",
	variants: "Biến thể",
	vehicle: "Phương tiện",
	vehicles: "Các phương tiện",
	verified_partner: "Đối tác đã xác minh",
	verify_password: "Xác nhận mật khẩu",
	visibility: "Tầm nhìn",
	warehouse: "Kho",
	warehouses: "Các kho",
	warn_unsaved_measurement: "Đừng quên nhấn ‘+’ để thêm các thông số đo của bạn.",
	website: "Trang web",
	week: "Tuần",
	weight: "Trọng lượng",
	weight_kg: "Trọng Lượng (kg)",
	welcome: "Chào mừng",
	what_we_are_doing: "Chúng tôi đang làm gì",
	width: "Chiều rộng",
	year: "Năm",
	year_lowercase: "năm",
	yearly: "Hàng năm",
	yes: "Có",
	yes_no: "Có / Không",
	you_dont_have_any_active_subscription: "Bạn không có đăng ký nào đang hoạt động.",
};
